import React, { useState } from "react";
import moment from "moment/moment";
import ArrowDownIcon from "../../assets/icons/arrowDown";
import PrevIcon from "../../assets/icons/prev";
import NextIcon from "../../assets/icons/next";
import { IoMdEye } from "react-icons/io";
import Popup from "./Popup";
import Textarea from "./Textarea";
import { FaFilePdf } from "react-icons/fa";
import { Link } from "react-router-dom";

const EmployeDocumentTable = ({ data }) => {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [requestOpen, setRequestOpen] = useState(false);

  const [selectedRow, setSelectedRow] = useState({});

  const handleRequestOpen = (row) => {
    setSelectedRow(row);
    setRequestOpen(true);
  };

  // Filter logic
  const filteredData = data?.filter((row) => {
    // return row?.title?.toLowerCase().includes(search.toLowerCase());
    return row;
  });

  const totalPages = Math.max(1, Math.ceil(filteredData?.length / rowsPerPage));

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const currentRows = filteredData?.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div className="w-full rounded-lg">
      {/* Filters */}
      {/* <div className="flex justify-between items-start md:flex-row gap-3 mb-4">
        <SearchInput
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by title..."
          fontSize="sm"
        />
      </div> */}

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="table-auto w-full text-sm">
          <thead>
            <tr className="h-[52px] bg-white border border-l-0 border-r-0 border-[#a48572]/10 text-[#142b70]">
              <th className="px-4 text-left text-sm font-semibold">S No.</th>
              <th className="px-4 text-left text-sm font-semibold">
                Document Type
              </th>
              <th className="px-4 text-center text-sm font-semibold">
                Request Date
              </th>
              <th className="px-4 text-center text-sm font-semibold">Status</th>
              <th className="px-4 text-center text-sm font-semibold"></th>
            </tr>
          </thead>
          <tbody>
            {currentRows?.length > 0 ? (
              currentRows.map((row, idx) => (
                <tr
                  key={idx}
                  className={`relative "text-[#142b70]/80 hover:bg-[#f9f9f9]`}
                >
                  <td className="relative px-4 text-left py-3 pl-3">
                    <p className="text-sm">
                      {(currentPage - 1) * rowsPerPage + idx + 1}
                    </p>
                  </td>
                  <td className="px-4 text-left py-3">
                    {row.document_type === "salary_transfer"
                      ? "Salary Transfer"
                      : row.document_type === "noc"
                      ? "NOC"
                      : row.document_type === "salary_certificate"
                      ? "Salary Certificate"
                      : "N/A"}
                  </td>
                  <td className="text-sm text-center py-3">
                    {row.updated_at
                      ? moment(new Date(row.updated_at)).format(
                          "DD MMM YYYY,  hh:mm A"
                        )
                      : "N/A"}
                  </td>
                  <td className="text-sm text-center py-3">
                    <div
                      className={`flex justify-center mx-auto items-center w-[90px] px-2 py-1 rounded ${
                        row.status === "Cancelled"
                          ? "bg-[#de2b26]/10"
                          : row.status === "Pending"
                          ? "bg-[#039dba]/10"
                          : "bg-[#32936f]/[0.16]"
                      }`}
                    >
                      <p
                        className={`text-xs ${
                          row.status === "Cancelled"
                            ? "text-[#142b70]"
                            : row.status === "Pending"
                            ? "text-[#039dba]"
                            : "text-[#519c66]"
                        }`}
                      >
                        {row.status}
                      </p>
                    </div>
                  </td>
                  <td className="text-sm text-center py-3 px-4">
                    <div className="flex gap-4 justify-end">
                      {row.status === "Approved" && (
                        <Link to={row?.file_path} target="_blank">
                          <FaFilePdf className="text-[#c30f0a] text-lg cursor-pointer" />
                        </Link>
                      )}
                      <IoMdEye
                        className="text-[#c30f0a] text-lg cursor-pointer"
                        onClick={() => handleRequestOpen(row)}
                      />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center mt-4 gap-4">
        <div className="relative w-[190px] h-[30px] flex items-center justify-between">
          {/* Page Selector */}
          <div className="flex items-center gap-2">
            <div className="flex items-center h-[26px] px-[10px] rounded-lg bg-[#f9f9f9] cursor-pointer relative">
              <select
                value={currentPage}
                onChange={(e) => handlePageChange(Number(e.target.value))}
                className="bg-transparent text-xs text-[#142b70]/80 focus:outline-none cursor-pointer appearance-none pr-5"
              >
                {Array.from({ length: totalPages }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </select>
              {/* Down Arrow */}
              <ArrowDownIcon
                iconClass="absolute right-2 pointer-events-none"
                color="#142b70"
              />
            </div>
            <p className="text-sm text-[#142b70]/80">of {totalPages} pages</p>
          </div>

          {/* Prev / Next Arrows */}
          <div className="flex items-center gap-3">
            {/* Prev */}
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="disabled:opacity-40"
            >
              <PrevIcon color="#142b70" />
            </button>

            {/* Next */}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="disabled:opacity-40"
            >
              <NextIcon color="#142b70" />
            </button>
          </div>
        </div>
      </div>
      <Popup
        isOpen={requestOpen}
        onClose={() => setRequestOpen(false)}
        title={`Document Request`}
      >
        <div className="flex flex-col gap-3 mt-[30px] border shadow rounded-xl p-6">
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Document Type</p>
            <span className="text-sm text-[#142b70]">
              {selectedRow.document_type === "salary_transfer"
                ? "Salary Transfer"
                : selectedRow.document_type === "noc"
                ? "NOC"
                : selectedRow.document_type === "salary_certificate"
                ? "Salary Certificate"
                : "N/A"}
            </span>
          </div>
          {selectedRow?.document_type === "salary_transfer" && (
            <div className="flex justify-between gap-2 w-full pb-2 border-b">
              <p className="text-sm text-[#142b70]/70">Bank Name</p>
              <span className="text-sm text-[#142b70]">
                {selectedRow?.bank_name}
              </span>
            </div>
          )}
          <div className="flex justify-between gap-2 w-full pb-2 border-b">
            <p className="text-sm text-[#142b70]/70">Request Date</p>
            <span className="text-sm text-[#142b70]">
              {moment(new Date(selectedRow?.updated_at)).format("DD MMM, YYYY")}
            </span>
          </div>
          {selectedRow.document_type === "noc" && (
            <>
              <div className="flex justify-between gap-2 w-full pb-2 border-b">
                <p className="text-sm text-[#142b70]/70">Subject</p>
                <span className="text-sm text-[#142b70]">
                  {selectedRow?.subject}
                </span>
              </div>
              <div className="flex justify-between gap-2 w-full pb-2 border-b">
                <p className="text-sm text-[#142b70]/70">To Whom</p>
                <span className="text-sm text-[#142b70]">
                  {selectedRow?.to_whom}
                </span>
              </div>
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/70">Reason</p>
                <Textarea
                  value={selectedRow?.reason}
                  disable={true}
                  className="bg-[#F9F9F9] border-0 shadow"
                />
              </div>
            </>
          )}
          {selectedRow.document_type === "salary_transfer" && (
            <>
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/70">Reason</p>
                <Textarea
                  value={selectedRow?.reason}
                  disable={true}
                  className="bg-[#F9F9F9] border-0 shadow"
                />
              </div>
            </>
          )}
        </div>
        {/* Footer */}
        <div className="flex justify-end gap-4">
          <button
            onClick={() => setRequestOpen(false)}
            className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
          >
            Close
          </button>
        </div>
      </Popup>
    </div>
  );
};

export default EmployeDocumentTable;
